import * as React from "react";
import {
  inputWrapper,
  sectionContainer,
  noSuggestionsDiv,
  searchResult,
  container,
} from "./FAQAutocomplete.module.scss";

export const InputWrapper: React.FC<any> = (props) => {
  return <div className={inputWrapper}>{props.children}</div>;
};

export const FAQContainer: React.FC<any> = (props) => {
  return <div className={container}>{props.children}</div>;
};

export const SectionContainer: React.FC<any> = (props) => {
  return (
    <div className={sectionContainer} {...props}>
      {props.children}
    </div>
  );
};

export const NoSuggestionsDiv: React.FC<any> = (props) => {
  return <div className={noSuggestionsDiv}>{props.children}</div>;
};

export const SearchResults: React.FC<any> = (props) => {
  return <div className={searchResult}>{props.children}</div>;
};
